import { IMediaItem } from 'modules/media/interfaces/api';
import React from 'react';
import { FolderCard } from '../LibraryList/FolderCard';
import { MediaCard } from '../LibraryList/MediaCard';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';

const MediaManagerGridModeMobile = ({
  items,
  onOpenFolder,
  currentPath,
}: {
  items: IMediaItem[];
  onOpenFolder: (folder: IMediaItem) => void;
  currentPath: string;
}) => {
  const mediaItems = items.filter((i) => i.type !== 'FOLDER');
  const navigate = useNavigate();

  const handlePreview = (id: string) => {
    const index = mediaItems.findIndex((i) => i.id === id);
    if (index === -1) return;

    navigate('/media-detail', {
      state: {
        index,
      },
    });
  };

  return (
    <>
      <Container>
        {items.map((item) =>
          item.type === 'FOLDER' ? (
            <FolderCard
              key={item.id}
              item={item}
              onClick={() => onOpenFolder(item)}
              length={item.children?.length || 0}
              currentPath={currentPath}
            />
          ) : (
            <MediaCard key={item.id} item={item} onClick={() => handlePreview(item.id)} currentPath={currentPath} />
          ),
        )}
      </Container>
    </>
  );
};

export default MediaManagerGridModeMobile;

const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
`;
